import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomGenericLinkModule } from '../../../shared/components/custom-generic-link/custom-generic-link.module';
import { CustomNavigationModule } from '../navigation/custom-navigation.module';
import { CustomFooterNavigationComponent } from './custom-footer-navigation.component';

@NgModule({
  declarations: [CustomFooterNavigationComponent],
  imports: [
    CommonModule,
    RouterModule,
    CustomGenericLinkModule,
    I18nModule,
    CustomNavigationModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        FooterNavigationComponent: {
          component: CustomFooterNavigationComponent,
        },
      },
    }),
  ],
})
export class CustomFooterNavigationModule {}
